module.exports = __webpack_public_path__ + "img/data_analytics.00cc95e2.webp";